import React from "react";
import {IListViewCreateDependedDocumentAction} from "../IListViewCreateDependedDocumentAction";
import {IListViewCreateMoreActions} from "../IListViewCreateMoreAction";

interface IProps {
    children?: React.ReactNode;
    onCreateNewClick?: () => void;
    onCloneClick?: () => void;
    onEditClick?: () => void;
    onShowTransactionsPage?: () => void;
    onShowPopup?: () => void;
    onDeleteClick?: () => void;
    onPostClick?: () => void;
    onCancelClick?: () => void;
    handleCreateDocumentActionPopupButtonClick?: () => void;
    handleCreateDocumentAction?: () => void;
    setCreateDocumentActionVisible?: (visible: boolean) => void;
    createDocumentActionVisible?: boolean;
    createDocumentActions?: IListViewCreateDependedDocumentAction[];
    createMoreActions?: IListViewCreateMoreActions[];
    handleClick?: () => void;
    handleComponentRefresh?: () => void;
    handleOpenMoreActions?: () => void;
    setCreateMoreActionsVisible?: (visible: boolean) => void;
    createMoreActionsVisible?: boolean;
    disabled?: any;
    handleOpenHierarchy?: () => void;
    selectedItemId?: string | undefined;
    handleSwitchViewType?: () => void;
    entity?: any;
    viewType?: string;
    handleCreateNewFolder?: () => void;
}

export const CatalogListViewToolbar = ({
                                           children,
                                           onDeleteClick,
                                           onCreateNewClick,
                                           onEditClick,
                                           onCloneClick,
                                           handleSwitchViewType,
                                           disabled,
                                           viewType,
                                           entity,
                                           handleCreateNewFolder,
                                       }: IProps) => {
    const arrayChildren = React.Children.toArray(children);

    return (
        <>
            <div className={"d-flex flex-wrap"}>
                {arrayChildren &&
                    arrayChildren.map((child: any, index) => {
                        return (
                            <React.Fragment key={index}>
                                {React.cloneElement(child, {
                                    onCreateNewClick: onCreateNewClick,
                                    entity: entity,
                                    onEditClick: onEditClick,
                                    disabled: disabled,
                                    onDeleteClick: onDeleteClick,
                                    viewType: viewType,
                                    onCloneClick: onCloneClick,
                                    handleSwitchViewType: handleSwitchViewType,
                                    handleCreateNewFolder: handleCreateNewFolder,
                                })}
                            </React.Fragment>
                        );
                    })}
            </div>
        </>
    );
};
